import { pageTitle } from "../PageTitle";

import HeaderOne from "../Header/HeaderOne";
import videoSource from "../../assets/videos/Document_intelligence_new.mp4";
import videoSource1 from "../../assets/videos/Document_Intelligence_Demo.mp4";
import architecture from "../../assets/images/resource/Document_Intelligence.png";
import FooterOne from "../Footer/FooterOne";
import SorBanner from "./../../assets/images/banner/azure-ai.png";
import di from "./../../assets/images/icons/di.jpg";
import msa from "./../../assets/images/icons/msa.png";

const DocumentIntelligence = () => {
  pageTitle("Document Intelligence");

  return (
    <>
      <HeaderOne></HeaderOne>

      <div
        className="ai-overlay-wrapper"
        style={{ backgroundImage: `url(${SorBanner})` }}
      >
        {/* <img src={SorBanner} alt="AI Operations" className="main" /> */}

        <div className="ai-overlay">
          {/* Centered text */}
          <img
            src={msa}
            alt="Microsoft azure"
            className="ai-overlay-corner-img"
          />
          <div className="ai-overlay-center-text">
            <h2 className="aai-h2">
              Azure AI Image Data <br />
              Extraction{" "}
            </h2>
            <p>
              <img src={di} alt="Microsoft azure" style={{ height: "30px" }} />{" "}
              Document Intelligence
            </p>
          </div>
        </div>
      </div>

      <section className="siw-rpa-section">
        <div className="siw-rpa-container-data-engineering container">
          <div className="siw-rpa-content">
            {/* <span className="siw-rpa-tag">
              Still Manually Searching item codes & rates in SOR (Schedule of
              Rates) documents?
            </span> */}

            <div className="siw-rpa-text">
              <p>
                Turn unstructured image documents into structured, actionable
                insights with an automated cloud-based workflow.
              </p>
            </div>

            <div className="siw-rpa-desc">
              <h3 className="pb-2">Key Capabilities</h3>
              <p>
                This solution automates document collection, data extraction,
                secure storage, and reporting with a modern Azure-based
                workflow:
              </p>
              <p
                className="py-2"
                style={{ fontWeight: "bold", color: "#009999" }}
              >
                The Five-Step Workflow
              </p>
              <ol>
                <li>
                  Collect – Documents are received from emails or manual
                  uploads.
                </li>
                <li>
                  Store – Files are securely stored in Azure Data Lake Storage.
                </li>
                <li>
                  Extract – Azure AI Document Intelligence captures and
                  structures key data.
                </li>
                <li>
                  Save – Structured output is stored in a database for reuse.
                </li>
                <li>
                  Visualize – Insights are displayed in Power BI dashboards for
                  analysis.
                </li>
              </ol>
            </div>
          </div>

          <div className="siw-rpa-cta">
            <h4 style={{ color: "rgb(230, 233, 55)" }}>Free Trial Available</h4>
            <p>
              <span style={{ fontSize: "20px", fontWeight: "bold" }}>SiW</span>{" "}
              is currently offering a free trial session. <br />
              Our team will create a dedicated AI Agents.
            </p>
            <p className="siw-project-website-text-top">
              To explore more about the{" "}
              <strong>Azure AI Image Data Extraction</strong>
              ,
              <br />
              Click 👉{" "}
              <a
                href="https://agents.siw.sg/"
                target="_blank"
                rel="noopener noreferrer"
                className="siw-project-website-link blinking1"
              >
                Azure AI Document Intelligence
              </a>
              .
            </p>
            <a href="/contact" className="siw-rpa-btn">
              <i className="bi bi-calendar-week btn-icon"></i>
              Start a Free Trial
            </a>
          </div>
        </div>
      </section>
      <div className="container" style={{ marginTop: "-10px" }}>
        <div className="siw-rpa-desc mt-0">
          <h3>Architecture</h3>
          <p className="pt-2">
            This diagram illustrates an automated cloud-based pipeline designed
            to transform unstructured Image documents into actionable insights.
            The workflow begins by gathering files from emails or manual uploads
            and centralizing them within Azure Data Lake Storage. Once stored,
            the system employs Azure AI Document Intelligence to digitally
            extract and interpret the contents of these files. Finally, the
            structured data is preserved in a database for long-term storage and
            visualized through Power BI to support advanced data analysis and
            business intelligence.
          </p>
          <img
            src={architecture}
            alt="Computer Vision"
            className="siw-rpa-desc-img"
          />
        </div>
      </div>

      <section className="siw-project-section">
        <div className="siw-project-container container">
          <div className="row g-4 align-items-start">
            <div className="col-md-6 mt-3">
              <h3 className="siw-project-heading">
                Introducing Azure AI Document Intelligence
              </h3>

              <div className="siw-project-video-wrapper">
                <iframe
                  className="siw-project-video"
                  src="https://www.youtube.com/embed/sbCRSkMJW9U?si=ob3pRkYFchVEWTB-"
                  title="Introducing Azure AI Document Intelligence"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>

            <div className="col-md-6 mt-3">
              <h3 className="siw-project-heading">Watch a Demo Video</h3>

              <div className="siw-project-video-wrapper">
                <iframe
                  className="siw-project-video"
                  src="https://www.youtube.com/embed/lPkB7uH38i4?si=4qBk9ZMXEEaFsJAE"
                  title="Watch a Demo Video"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
          <p className="siw-project-website-text">
            To explore more about the{" "}
            <strong>Azure AI Image Data Extraction</strong>
            , <br />
            Click 👉{" "}
            <a
              href="https://agents.siw.sg/"
              target="_blank"
              rel="noopener noreferrer"
              className="siw-project-website-link blinking"
            >
              Azure AI Document Intelligence
            </a>
            .
          </p>
        </div>
      </section>
      <FooterOne></FooterOne>
    </>
  );
};
export default DocumentIntelligence;
